/**
 * Generated runtime TestId mirror for frontend/src/features/certification/components/WizardStepBasics.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const WizardStepBasicsTestIds = {
  checkboxPolicyActive: "checkbox-policy-active",
  datepickerValidFrom: "datepicker-valid-from",
  datepickerValidTo: "datepicker-valid-to",
  errorValidTo: "error-valid-to",
  inputPolicyDescription: "input-policy-description",
  inputPolicyName: "input-policy-name",
  inputPolicyPriority: "input-policy-priority"
} as const;
